import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDyyI_2-hX3yZCg-5StuuxRRarmjzrVJFk",
    authDomain: "ayur-47b6c.firebaseapp.com",
    projectId: "ayur-47b6c",
    storageBucket: "ayur-47b6c.firebasestorage.app",
    messagingSenderId: "621265028659",
    appId: "1:621265028659:web:296fd06998a6646f9b4546",
    measurementId: "G-5SPVVJN60K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
